import { LazyRouteDefinition, createRouteViewSwitch } from '../../util-routing'
import { InsiderView, InsiderViewParam } from './constants'

const { loader, action, lazySwitch } = createRouteViewSwitch({
  defaultView: InsiderView.Index,
  viewParam: InsiderViewParam.View,
  views: {
    '': {
      LazyComponent: () => import(/* webpackChunkName: "insider-index" */ './routes/Index'),
    },
    [InsiderView.Managers]: {
      LazyComponent: () => import(/* webpackChunkName: "insider-managers" */ './routes/Managers'),
    },
    [InsiderView.ManagerDetails]: {
      LazyComponent: () => import(/* webpackChunkName: "insider-manager-details" */ './routes/ManagerDetails'),
    },
    [InsiderView.ManagerHoldings]: {
      LazyComponent: () => import(/* webpackChunkName: "insider-manager-holdings" */ './routes/ManagerHoldings'),
    },
    [InsiderView.Funds]: {
      LazyComponent: () => import(/* webpackChunkName: "insider-funds" */ './routes/Funds'),
    },
    [InsiderView.FundDetails]: {
      LazyComponent: () => import(/* webpackChunkName: "insider-fund-details" */ './routes/FundDetails'),
    },
    [InsiderView.FundHoldings]: {
      LazyComponent: () => import(/* webpackChunkName: "insider-fund-holdings" */ './routes/FundHoldings'),
    },
    [InsiderView.NotFound]: {
      LazyComponent: () => import(/* webpackChunkName: "insider-not-found" */ './routes/NotFound'),
    },
  },
})

export const insiderTradingModule: LazyRouteDefinition[] = [
  {
    path: '/insidertrading.ashx',
    loader,
    action,
    lazy: lazySwitch,
  },
]
